import { withFirebase } from "../Firebase";
import React, { Component } from "react";

import { Intent, ButtonGroup, Button, AnchorButton, Popover, Position,  Menu, MenuDivider, MenuItem  } from "@blueprintjs/core";

import { Row, Col } from "react-flexbox-grid";
import ReactDataGrid from "react-data-grid";
import "./index.css";
import Spinner from "react-md-spinner";

import { CSVLink } from "react-csv";
import cols from "./auxiliary/cols"; 
import paresRows from "./auxiliary/rows"; 

const {
  DraggableHeader: { DraggableContainer },
  Toolbar,
  Filters: { AutoCompleteFilter, MultiSelectFilter, SingleSelectFilter },
  Data: { Selectors },
} = require("react-data-grid-addons");

const selectors = Selectors;

class UserTable extends Component {
 
  
  quesitons_cols = [];

  constructor(props) {
    super(props);
    //fetch questions and append them to the cols array
    if (
      this.props.confirmType === "filter" ||
      Object.keys(this.props.form).length > 0
    ) {
      let questions = this.props.form.questions;
      let defaultQuestionMap = {
        "كيف سمعت عن هذه الورشة؟ (اختر جميع ما ينطبق)": "channel source",
        "مالذي دفعك للتسجيل في هذه الورشة؟ (اختر جميع ما ينطبق)":
          "registation motive",
        "مالذي دفعك للتسجيل في هذه الورشة؟ وماهي توقعاتك لمحتوى/ مخرجات الورشة؟":
          "registation motive and expectations",
      };

      for (let i in questions) {
        if (
          (questions[i].type === "mcq" || questions[i].type === "cbq") &&
          questions[i].text in defaultQuestionMap
        ) {
          this.quesitons_cols.push({
            key: questions[i].text
              .toLowerCase()
              .split(" ")
              .join("_"),
            name: defaultQuestionMap[questions[i].text],
            width: 150,
            filterRenderer:
              questions[i].type === "long_text"
                ? AutoCompleteFilter
                : MultiSelectFilter,
            resizable: true,
            sortable: true,
            filterable: true,
            visible: true,
            draggable: true,
            type: questions[i].type,
            text: questions[i].text,
          });
        } else {
          this.quesitons_cols.push({
            key: questions[i].text
              .toLowerCase()
              .split(" ")
              .join("_"),
            name: questions[i].text.replace(/,/g, ";"),
            width: 150,
            filterRenderer:
              questions[i].type === "long_text" || questions[i].type === "text"
                ? AutoCompleteFilter
                : MultiSelectFilter,
            resizable: true,
            sortable: true,
            filterable: true,
            visible: true,
            draggable: true,
            type: questions[i].type,
            text: questions[i].text,
          });
        }
      }

      Array.prototype.push.apply(cols, this.quesitons_cols);
    }
 
    this.state = {
      loading: true,
      selectedIndexes: [],
      selectedUsers: [],
      columns: cols.filter((col) => col.visible === true),
      rows: [],
      originalRows: [],
      userlist: [],
      startCell: 0,
      endCell: 0,
      filters: {},
      csvFile: "",
    };
    this.handleSendEmail = this.handleSendEmail.bind(this);
  }



  async componentDidMount() {
  
      this.setState({loading: true});

      //fetch registations ...
      let snap_regisrtations = await this.props.firebase
        .registrations(this.props.eventId)
        .get();
      let regisrtations = snap_regisrtations.docs.map((doc) =>{ return {
                                                   ...doc.data(),
                                                   id: doc.id,
                                                 }; });                                     
      //fetch user data...
      let promises = regisrtations.map((registation) =>
        this.props.firebase.realUser(registation.id).get()
      ); 
      let snap_users = await Promise.all(promises);                                  
      let users = snap_users.map((doc) => {
        return {
          ...doc.data(),
          id: doc.id,
        };
      }); 

      let userList = regisrtations.map(val => {
        var id = val.id; 
        var index = users.findIndex(val => val.id === id); 
        return {...val, ...users[index]}

      })

      this.setState({
        loading: false,
        userlist: userList,
        rows: paresRows(this.props,this.quesitons_cols, userList).slice(0),
        originalRows: paresRows(this.props,this.quesitons_cols, userList),
      }); 
   

      
  }
  
  handleGridSort(sortColumn, sortDirection) {
    const comparer = (a, b) => {
      if (sortColumn === "registration_date") {
        var aSplit = a[sortColumn].split(".");
        var aDate = new Date(aSplit[2], aSplit[1] - 1, aSplit[0]);

        var bSplit = b[sortColumn].split(".");
        var bDate = new Date(bSplit[2], bSplit[1] - 1, bSplit[0]);
      }

      if (sortDirection === "ASC") {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.rows.sort(comparer);
    this.setState({ rows: rows });
  }

  handleFilterChange(filter) {
    let newFilters = Object.assign({}, this.state.filters);
    console.log(newFilters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }

    this.setState({ filters: newFilters });
  }

  getValidFilterValues(columnId) {
    let values = this.state.rows.map((r) => r[columnId]);

    return values.filter((item, i, a) => {
      return i === a.indexOf(item);
    });
  }

  getRows(rows, filters) {
    return selectors.getRows({ rows, filters });
  }

  handleClearFilters = () => {
    this.setState({ filters: Object.assign({}) });
  };

  onRowsSelected = (users) => (rows) => {
    //test case 1: select all then filter/order doesn't update existing list ... (-)
    //test case 2: select all with filter doesn't work ... (done)
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map((r) => r.rowIdx)
      ),
      selectedUsers: this.state.selectedUsers.concat(
        rows.map((r) => {
          if (users[r.rowIdx] !== undefined) return users[r.rowIdx].id;
        })
      ),
    });
    console.log(this.state.selectedUsers);
  };

  onRowsDeselected = (users) => (rows) => {
    let rowIndexes = rows.map((r) => r.rowIdx);
    let users_id = rows.map((r) => {
      if (users[r.rowIdx] !== undefined) return users[r.rowIdx].id;
    });
    this.setState({
      selectedIndexes: this.state.selectedIndexes.filter(
        (i) => rowIndexes.indexOf(i) === -1
      ),
      selectedUsers: this.state.selectedUsers.filter(
        (i) => users_id.indexOf(i) === -1
      ),
    });

  };

  zoomAttendence = async () => {

    let eventId = this.props.eventId;
    let { userlist } = this.state;

    try {

    //fetch the latest list from firebase
    this.setState({loading: true}); 
    let url =
      "https://thakaa-services-ganwddtzfa-uc.a.run.app/events/attendance/zoom"; 

    let params = {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({
      event_id: eventId,
    }),
    }

  await fetch(url, params).then(res => {
      if(res.status === 200) console.log("data sent successfully...");
      else console.log("error"); 
      return res.json(); 
    }).then(data => {

        let attended = data.user_list.map(val => val.uid); 
          
          userlist = userlist.map(val => {
            if(attended.includes(val.id)){
              val.attended = "Yes"
            }
            return val; 
          }); 

    }).catch(e => {
      console.log(e); 
      throw e; 
    });

 
    this.setState({
    loading:false,
    rows: paresRows(this.props, this.quesitons_cols, userlist),
    userlist: userlist,
    });

    }
    catch(e){

      this.setState({
        loading:false,
      });
      console.log("error marking attended records...", e);
    }

  }
 
  handleSendEmail = async (status) => {

    let eventId = this.props.eventId;
    let { selectedUsers, userlist } = this.state;


    try {

    //fetch the latest list from firebase
    this.setState({loading: true}); 
  
    let url = `https://thakaa-services-ganwddtzfa-uc.a.run.app/events/registrations/batch/${status}`; 

    userlist = userlist.map(val => {
      if(selectedUsers.includes(val.id)){
        val[status] = "Yes";
      }
      return val; 
    }); 

    var list = userlist.filter(val => selectedUsers.includes(val.id)).map(val => {
      return {uid: val.id, email: val.email}
    }); 


    console.log(list); 
    let params = {
      method: "PATCH",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({
      event_id: eventId,
      user_list: list,
    }),
    }

    await fetch(url, params).then(res => {
      if(res.status === 200) console.log("data sent successfully...");
      else console.log("error"); 
    }).catch(e => {
      console.log(e); 
      throw e; 
    })

    this.setState({
    loading:false,
    rows: paresRows(this.props, this.quesitons_cols, userlist).slice(0),
    userlist: userlist,
    });

    }
    catch(e){

      this.setState({
        loading:false,
      });
      console.log("error deleting this record...", e);
    }
   
  

  };



  deleteUsers = async () => {
    let eventId = this.props.eventId;
    let { selectedUsers, userlist } = this.state; 

    try {

    //fetch the latest list from firebase
    this.setState({loading: true}); 

    userlist = userlist.filter(val => !selectedUsers.includes(val.id)); 

    console.log(selectedUsers); 

    await this.props.firebase
      .event(eventId)
      .update({ 
        registrationids: this.props.firebase.arrayRemove(selectedUsers),
       })
      .then(() => {
        console.log("updated successfully");
        return 0;
      })
    
 
    await Promise.all(selectedUsers.map(uid => this.props.firebase
    .registration(eventId, uid)
    .delete()
    .then(() => console.log("deleted successfully"))));


    this.setState({
    loading:false,
    selectedUsers: [],
    rows: paresRows(this.props, this.quesitons_cols, userlist),
    userlist: userlist,
    });

    }
    catch(e){

      this.setState({
        loading:false,
      });
      console.log("error deleting records...", e);
    }

  };

  onHeaderDrop = (source, target) => {
    const stateCopy = Object.assign({}, this.state);
    const columnSourceIndex = this.state.columns.findIndex(
      (i) => i.key === source
    );
    const columnTargetIndex = this.state.columns.findIndex(
      (i) => i.key === target
    );

    stateCopy.columns.splice(
      columnTargetIndex,
      0,
      stateCopy.columns.splice(columnSourceIndex, 1)[0]
    );

    const emptyColumns = Object.assign({}, this.state, { columns: [] });
    this.setState(emptyColumns);

    const reorderedColumns = Object.assign({}, this.state, {
      columns: stateCopy.columns.filter((col) => col.visible === true),
    });
    this.setState(reorderedColumns);
  };

  render() {
    const { loading, userlist, rows, filters } = this.state;
    const filteredRows = this.getRows(rows, filters);
    const eventName =
      this.props.eventName === undefined
        ? ""
        : this.props.eventName
            .split(" ")
            .join("_")
            .toLowerCase();
    console.log(this.state.selectedUsers);
    if(loading) return (
                  <Spinner
                    size={100}
                    style={{ marginTop: "20%", marginLeft: "50%" }}
                    singleColor="#1673b5"
                  />
                );
    return (
      <div>
        <Row>
          {userlist.length !== 0 ? (
            <DraggableContainer onHeaderDrop={this.onHeaderDrop}>
              <ReactDataGrid
                columns={this.state.columns}
                rowGetter={(i) => filteredRows[i]}
                rowsCount={userlist.length}
                toolbar={<Toolbar enableFilter={true} />}
                onGridSort={(sortColumn, sortDirection) =>
                  this.handleGridSort(sortColumn, sortDirection)
                }
                onAddFilter={(filter) => this.handleFilterChange(filter)}
                getValidFilterValues={(colId) =>
                  this.getValidFilterValues(colId)
                }
                onClearFilters={() => this.handleClearFilters()}
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected: this.onRowsSelected(filteredRows),
                  onRowsDeselected: this.onRowsDeselected(filteredRows),
                  selectBy: {
                    indexes: this.state.selectedIndexes,
                  },
                }}
              />
            </DraggableContainer>
          ) : (
            <h2>Users aren't registered yet</h2>
          )}
        </Row>
        <Row>
          <Col xs={8}>
            <Row> Total Registered: {filteredRows.length}</Row>
            <Row>
              
              Total Attended:
              {filteredRows.filter((val) => val.attended === "Yes").length}
            </Row>
            <Row>
              
              Total Rejected:
              {filteredRows.filter((val) => val.rejected === "Yes").length}
            </Row>
            <Row>
              
              Total Confirmed:
              {
                filteredRows.filter((val) => val.confirmed === "Yes").length
              }
            </Row>
            <Row>
              
              Total Canceled:
              {filteredRows.filter((val) => val.canceled === "Yes").length}
            </Row>
          </Col>
          <Col xs={4}>
            <ButtonGroup>
              <CSVLink filename={`${eventName}.csv`} data={this.state.csvFile}>
                <Button
                  icon="th-derived"
                  intent={Intent.SUCCESS}
                  onClick={() => this.exportTable(filteredRows)}
                >
                  Export Table
                </Button>
              </CSVLink>

              <Popover
                content={
                  <Menu>
                    <MenuItem
                      text="Confirm"
                      icon="envelope"
                      intent={Intent.PRIMARY}
                      onClick={() => this.handleSendEmail("confirmed")}
                      disabled={
                        this.state.selectedIndexes.length === 0 ? true : false
                      }
                    />

                    <MenuItem
                      text="Reject"
                      icon="envelope"
                      intent={Intent.PRIMARY}
                      onClick={() => this.handleSendEmail("rejected")}
                      disabled={
                        this.state.selectedIndexes.length === 0 ? true : false
                      }
                    />
                    <MenuItem
                      text="Zoom Attendence"
                      icon="tick"
                      intent={Intent.PRIMARY}
                      onClick={this.zoomAttendence}
                      disabled={!this.props.isWebinar}
                    />

                    <MenuItem
                      text="Mark Attended"
                      icon="tick"
                      intent={Intent.SUCCESS}
                      onClick={() => this.handleSendEmail("attended")}
                      disabled={
                        this.state.selectedIndexes.length === 0 ? true : false
                      }
                    />

                    <MenuItem
                      text="Delete User"
                      icon="trash"
                      intent={Intent.DANGER}
                      onClick={this.deleteUsers}
                      disabled={
                        this.state.selectedIndexes.length === 0 ? true : false
                      }
                    />
                    <MenuDivider />
                    <MenuItem text="Exit" icon="cross" />
                  </Menu>
                }
                position={Position.BOTTOM_LEFT}
              >
                <AnchorButton rightIcon="caret-down">
                  Perform Action
                </AnchorButton>
              </Popover>
            </ButtonGroup>
          </Col>
        </Row>
      </div>
    );
  }

  
  exportTable = (rows) => {
    var csv = [];
    
    var selected_indexes = this.state.selectedIndexes;

    let col_titles = "";
    for (let i = 0; i < cols.length; i++) {
      col_titles += cols[i].name + ",";
    }

    csv.push(col_titles);
    console.log(csv);
    for (let i = 0; i < selected_indexes.length; i++) {
      let index = selected_indexes[i];
      if (rows[index] === undefined) break;
      let row = "";

      for (let j = 0; j < cols.length; j++)
        row += rows[index][cols[j].key] + ",";
      console.log(row);
      csv.push(row);
    }

    console.log(csv);
    // Download CSV file
    this.setState({ csvFile: csv.join("\n") });
  };

  
}

export default withFirebase(UserTable);
